import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 450px;
  width: 100%;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Title = styled.div`
  font-family: "Mangueira Bold";
  font-size: 14px;
  line-height: 22px;
  color: ${({ theme }) => theme.colors.blue};
`;

export const Subtitle = styled.div`
  font-size: 14px;
  line-height: 22px;
  color: ${({ theme }) => theme.colors.gray};
`;

export const Body = styled.div`
  display: flex;
  margin-top: 30px;
  padding-top: 12px;
  border-top: 1px dashed rgba(0, 0, 0, 0.1);
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 16px;

  & button {
    width: 100%;
    margin-top: 20px;
  }
`;

export const FormItem = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ContainedButtonWarn = styled.div`
  & button {
    background-color: ${({ theme }) => theme.colors.blueClean};
    color: ${({ theme }) => theme.colors.blue};
    margin: 0;
  }
`;
